<kp-detail-view-action
  [showEditableAction]="notification?.isEditing"
  [showCompactAction]="!notification?.isEditing"
  (trashIconClicked)="deleteReminder()"
  [saveDisabled]="saveDisabled"
  (saveClicked)="saveReminder()">
  <div class="diamond-row" expanded>
    <kp-action-reminder-diamond
      *ngFor="let day of dateTimeUtil.allDays"
      [day]="day"
      [isSelected]="days?.includes(dateTimeUtil.weekDaysData[day].abbreviation)"
      (reminderDay)="updateDay($event)"></kp-action-reminder-diamond>
    <kp-action-reminder-time-selector
      class="time-picker"
      [time]="timeToEdit"
      (timeEventEmitter)="updateTime($event)"></kp-action-reminder-time-selector>
  </div>
  <button class="reminder-row" (click)="showExpandedView()" compact>
    <svg-icon class="reminder" src="/assets/icons/reminder.svg"></svg-icon>
    <p class="display-days">{{ selectedDays }} &bull; {{ timeFromCardNotification }}</p>
    <svg-icon class="icon-button edit" src="/assets/icons/edit.svg"></svg-icon>
  </button>
</kp-detail-view-action>
